import React, { Component } from 'react';
import { connect } from 'react-redux';
import FeedbackComponent from '../../../components/troubleShooting/articleDetails/FeedbackComponent';
import { saveFeedbackAction } from '../../../store/troubleShooting/articleDetail/action';
import ReactGA from "react-ga4";
import { deviceDetect } from "react-device-detect";
import noFeedbackOptions from "../../../assets/lang/jp/feedbcakNoOptions.json";


class FeedbackContainer extends Component {
    constructor(props) {
        super(props);
        this.saveFeedback = this.saveFeedback.bind(this);
        this.state = {
            isOpen: false,
            disAllowFB: 0,
            isHelpFul: 0,
            isSelected: 0,
            noFeedbackOptionID:'',
            noFeedbackOptionName: '',
            noFeedbackOptionIDParent:'',
            noFeedbackOptionNameParent: '',
            noFeedbackOptionSelected: 0,
            allOptions : noFeedbackOptions,
            NoFeedbckchildrenOptions : '',
            haschildren : 0
            //sessionID: (this.props.sessionId) ? this.props.sessionId: ''
        }
    }
     
    /* Open close NoFeedback Option Model */
    openModal = () => {
        console.log(this.props.authData.auth.userId);
        this.setState({ isOpen: true }); 
        this.setState({isHelpFul: 0});
        ReactGA.event('Click', {
            category: 'Solved',
            action: 'Click',
            event_category: 'Solved',
            event_action: 'Click',
            event_label: 'No',
            UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
        });

        }
    closeModal = () => this.setState({ isOpen: false });

    /* Get Option Name by id */
    getOptionName = (optionID) => {

        let optionsNoFeedback = this.state.allOptions;
        let optionarray= optionsNoFeedback.feedbackNoOptions;

        let result = optionarray.filter(obj => {
            return obj.optionId === optionID
          })

        if(result.length > 0) {

            const selectedOption = result[0];

            return selectedOption.optionName;

        } else {
 
            let NoFeedbckchildrenOptions = this.state.NoFeedbckchildrenOptions

            let optionArr = NoFeedbckchildrenOptions.filter(obj => {
                return obj.optionId === optionID
                })

              const selectedOption = optionArr[0];

              return selectedOption.optionName;

        }

    }

  
    /* NoFeedback option change Event */
    handleInputChange = (event) => {
      
        const target = event.target;
        const value = target.type === 'radio' ? target.value : '';
        const name = target.name;

        const optionID = value;

        let optionNameValue = this.getOptionName(value);
        ReactGA.event('Select'.concat('-', optionID), {
            category: 'NoFeedbackSelection',
            action: 'Select'.concat('-', optionID),
            event_category: 'NoFeedbackSelection',
            event_action: 'Select'.concat('-', optionID),
            event_label: optionNameValue,
			event_value: optionNameValue,
            UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
			
        });

        if(this.state.haschildren === 1) {

            /* eslint-disable */
            let countUnderScore = (optionID.match(/\_/g) || []).length;
             if(countUnderScore === 1) {

               this.setState({

                   noFeedbackOptionIDParent : '',
                   noFeedbackOptionNameParent: '',
                   haschildren: 0


               });

           }

       }

        this.setState({
          [name]: optionID,
          noFeedbackOptionName : optionNameValue,
          noFeedbackOptionSelected: 1

        });

        console.log('Selected Option ID:', optionID);

        console.log('Selected Option Name:', optionNameValue);
       



      }   


      /* if option has suboptions */
      getchildren = (e) => {

        let optionsNoFeedback = this.state.allOptions;
        let optionarray= optionsNoFeedback.feedbackNoOptions;

        if(this.state.haschildren === 0) {

        const yesBtn = document.querySelector('input[name="noFeedbackOptionID"]:checked') 
        if(yesBtn) {

            yesBtn.checked = false;

        }
       

        let  noFeedbackOptionID = e.target.dataset.value
        let  optionNameValue = this.getOptionName(noFeedbackOptionID);

        console.log('Selected Option ID:', noFeedbackOptionID);

        console.log('Selected Option Name:', optionNameValue);

        ReactGA.event('Select'.concat('-',noFeedbackOptionID), {
            category: 'NoFeedbackSelection',
            action: 'Select'.concat('-',noFeedbackOptionID),
            event_category: 'NoFeedbackSelection',
            event_action: 'Select'.concat('-',noFeedbackOptionID),
            event_label: optionNameValue,
			event_value: optionNameValue,
            UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
        });

        
        let optionArr = optionarray.filter(obj => {
            return obj.optionId === noFeedbackOptionID
            })

          let childrenOptions = optionArr[0];

          childrenOptions = childrenOptions.children

        this.setState({
            haschildren: 1,
            noFeedbackOptionIDParent: noFeedbackOptionID,
            noFeedbackOptionNameParent : optionNameValue,
            NoFeedbckchildrenOptions : childrenOptions,
            noFeedbackOptionSelected: 0

        })

        } else {

            this.setState({
                haschildren: 0,
                noFeedbackOptionIDParent: '',
                noFeedbackOptionNameParent : '',
                noFeedbackOptionID:'',
                noFeedbackOptionName: '',
                noFeedbackOptionSelected: 0
    
            })

        }

        
    
    
      }

    /**
     *  @method: saveFeedback to store the user feedback
     *  @param:  sessionID, articleID, isHelpFul
     *  @returns: object with status 
     */
    saveFeedback(e) {
        let feedback = e.target.dataset.value;

        let fbReq = {
            "AddFeedbackRequest": {
                //"sessionID":  this.props.sessionId,
                "articleID": this.props.articleId,
                "isHelpFul": feedback
                }           
            }           
                        
        ReactGA.event('Click', {
            category: 'Solved',
            action: 'Click',
            event_category: 'Solved',
            event_action: 'Click',
            event_label: e.target.dataset.value === '1' ? 'Yes' : 'No',
            UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
        });

        this.setState({
            disAllowFB: true,
            isHelpFul: feedback,
            isSelected: 1
        });
        this.props.saveFeedback(fbReq);
    }

    /* No Feedback From submit */

    noFeedbackSubmit = (e) => {

        e.preventDefault();

        console.log('Submitted Option ID:', this.state.noFeedbackOptionID);

        console.log('Submitted Option Name:', this.state.noFeedbackOptionName);

        //  let noFeebackoptionDB  = this.state.noFeedbackOptionID.concat('-',this.state.noFeedbackOptionName)

        //  if(this.state.noFeedbackOptionIDParent){
        //     noFeebackoptionDB = (this.state.noFeedbackOptionIDParent.concat('-', this.state.noFeedbackOptionNameParent)).concat(' ',noFeebackoptionDB)
        //  }

         let noFeebackoptionID  = this.state.noFeedbackOptionID

         let noFeebackoptionName  = this.state.noFeedbackOptionName

         if(this.state.noFeedbackOptionIDParent){

            noFeebackoptionID = this.state.noFeedbackOptionIDParent.concat('-', noFeebackoptionID)
            noFeebackoptionName = this.state.noFeedbackOptionNameParent.concat('-', noFeebackoptionName)
         }

        let fbReq = {
            "AddFeedbackRequest": {
                //"sessionID":  this.props.sessionId,
                "articleID": this.props.articleId,
                "isHelpFul": '0',
                "noFeedbackOption": noFeebackoptionName
                }           
            }   
                             
        ReactGA.event('Click'.concat('-', noFeebackoptionID) ,  {
            category: 'NoFeedbackOptionSubmitted',
			action: 'Click'.concat('-', noFeebackoptionID),
			event_category: 'NoFeedbackOptionSubmitted',
			event_action: 'Click'.concat('-', noFeebackoptionID),
			event_label: noFeebackoptionName,
			event_value: noFeebackoptionName,
            UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
        });

        this.setState({
            disAllowFB: true,
            isHelpFul: 0,
            isSelected: 1,
            isOpen: false
        });

        this.props.saveFeedback(fbReq);

    }

    render() {
        let device = deviceDetect();

        return (
            <div>
                <FeedbackComponent haschildren={this.state.haschildren} getchildren={this.getchildren}  NofeedbackOptionsData={this.state.allOptions} noFeedbackOptionSelected={this.state.noFeedbackOptionSelected} saveNoFeedback={this.noFeedbackSubmit} fbHandler={this.saveFeedback} openModal={this.openModal} closeModal={this.closeModal} clickHandler={this.props.clickHandler} pageData={this.props.pageData} btnDisable={this.state.disAllowFB} isOpen={this.state.isOpen}  isHelpFul={this.state.isHelpFul} isSelected={this.state.isSelected} detectedDevice={device} handleInputChange={this.handleInputChange} userID= {this.props.authData.auth.userId}/>
            </div>
        );
    }
}


/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
    saveFeedback: saveFeedbackAction
    

};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
    authData: state.auth
  
  })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FeedbackContainer);